import PageCompiler from '@edools/page-compiler'
import lodashIsEmpty from 'lodash.isempty'
import lodashMerge from 'lodash.merge'
import lodashCloneDeep from 'lodash.clonedeep'

export default (id, options, siblings, title) => {
  const SECTIONS = PageCompiler.defaults.sections
  const section = lodashCloneDeep(SECTIONS.empty)

  section.id = id
  section.title = title
  section.options.sm.position = siblings.length
  section.options.md.position = siblings.length
  section.options.lg.position = siblings.length

  const isEmpty = !lodashIsEmpty(options)

  if (isEmpty) {
    lodashMerge(section.options, options)
  }

  return section
}
